import type { HideableBanner } from 'constants/routeVisibilityConfig'
import { BANNER_ROUTE_CONFIG } from 'constants/routeVisibilityConfig'
import { matchLocaleAwarePath } from './matchLocaleAwarePath'

function getRouteSpecificity(route: string): number {
  return route
    .split('/')
    .filter(Boolean)
    .filter(segment => !segment.startsWith(':'))
    .length
}

export function isBannerHiddenForPath(
  currentPath: string,
  banner: HideableBanner,
): boolean {
  const configEntries = Object.entries(BANNER_ROUTE_CONFIG)

  const exactRoutes: Array<[string, Array<HideableBanner>]> = []
  const wildcardRoutes: Array<[string, Array<HideableBanner>]> = []

  for (const entry of configEntries) {
    const [route] = entry
    if (route.endsWith('/*')) {
      wildcardRoutes.push(entry)
    } else {
      exactRoutes.push(entry)
    }
  }

  const sortedExactRoutes = [...exactRoutes].sort(([routeA], [routeB]) => {
    return getRouteSpecificity(routeB) - getRouteSpecificity(routeA)
  })

  for (const [route, hiddenBanners] of sortedExactRoutes) {
    if (matchLocaleAwarePath(currentPath, { path: route, exact: true })) {
      return hiddenBanners.includes(banner)
    }
  }

  for (const [route, hiddenBanners] of wildcardRoutes) {
    const routePrefix = route.slice(0, -2)
    if (matchLocaleAwarePath(currentPath, { path: routePrefix, exact: false })) {
      return hiddenBanners.includes(banner)
    }
  }

  return false
}
